<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!--  -->
              <h4 class="page-header">
                Search database for matches
              </h4>

              <!-- Search Area -->
              <div class="p-2 border rounded">
                <fieldset>
                  <div class="row">
                    <div class="col-md-5">
                      <div class="form-group">
                        <label for="search-term" style="color: black;"
                          >Enter any username, email, firstname,
                          lastname:</label
                        >
                        <input
                          v-model="SearchTerm"
                          type="text"
                          id="search-term"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <input
                      type="button"
                      value="Search"
                      class="btn btn-primary"
                      @click="getData"
                    />
                  </div>
                </fieldset>
              </div>

              <!-- Result Table -->
              <GeneralLookupResultTable ref="table" :SearchTerm="SearchTerm" />
              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DivvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import GeneralLookupResultTable from "./GeneralLookupResultTable.vue";

export default {
  name: "GeneralLookup",
  data() {
    return {
      SearchTerm: "",
    };
  },
  components: {
    Header,
    Footer,
    DivvyAdminSidebar,
    GeneralLookupResultTable,
  },
  // watch: {
  //   SearchTerm(newVal) {

  //   },
  // },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "generalLookup",
        activeMenu: this.activeMenu ? this.activeMenu : "utilities",
      });
    },
    setSearchTerm() {
      this.$store.commit("generalLookup/SET_SEARCH_TERM", this.SearchTerm);
    },
    getData() {
      this.setSearchTerm();
      try {
        // console.log(this.$refs.table.updateData);
        this.$store.commit("generalLookup/SET_PAGE_NUMBER", 1);
        this.$refs.table.updateData();
        // this.SearchTerm = "";
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
